export enum CustomerSearchFocusFieldEnum {
  ORDER_ID = "OrderId",
  CARD_NUMBER = "CardNumber",
  CUSTOMER_ID = "CustomerId",
  CUSTOMER_NAME = "CustomerName",
  FIRST_NAME = "FirstName",
  LAST_NAME = "LastName",
  PHONE_NUMBER = "PhoneNumber",
  ADDRESS = "Address",
  SITE_NAME = "SiteName",
  BUILDING_NAME = "BuildingName",
  DOOR_NUM = "DoorNum",
}
